/**
 * The end of a run.
 *
 * The reasons shown here are assembled by the engine from the run log itself — which
 * pillar went first, whose savings ran out, whether repression backfired — so they cannot
 * drift from what actually happened. This is the "what changed the outcome" summary, and
 * it is the part most worth reading.
 */

import type { RunLog } from 'walkout-engine';
import './Outcome.css';

const HEADLINE: Record<RunLog['outcome']['kind'], string> = {
  conceded: 'The demands were met',
  negotiated: 'A partial settlement',
  stalemate: 'Neither side broke',
  collapse: 'The campaign collapsed',
  'violent-escalation': 'It turned violent',
};

export function Outcome({ run }: { run: RunLog }) {
  const { outcome } = run;
  return (
    <section className={`outcome outcome--${outcome.kind}`}>
      <div className="outcome__head">
        <span className="label">Day {outcome.day}</span>
        <h2 className="outcome__headline">{HEADLINE[outcome.kind]}</h2>
      </div>
      <ul className="outcome__reasons">
        {outcome.reasons.map((reason) => (
          <li key={reason}>{reason}</li>
        ))}
      </ul>
    </section>
  );
}
